;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import get from "lodash/get"
import { COHORT_SCHEDULE_EXACT } from "../constants"

type CohortLike = {
  schedule?: Record<string, unknown>
}

const isCohortScheduleSpecificDates = (
  cohort: CohortLike | null | undefined,
): boolean => {
  return (
    (get(cohort, `schedule[${COHORT_SCHEDULE_EXACT}]`, []) as unknown[]).length > 0
  )
}

export default isCohortScheduleSpecificDates
